import {IHotel} from '../../../types/hotel';

export const getHotels = async (id: number) => {
  const queryUrl = `${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_UPLOAD_HOTELS}?id=${id}`;
  const response = await fetch(queryUrl);
  const data = await response.json();
  const hotelData: IHotel = data?.hotel;

  return hotelData;
}